module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_1-542ae0dc410cdc363844b66d3e64ccbc.jpg";